import { Inbox } from "lucide-react";
import type { FC } from "react";
import React from "react";

import { hasValue } from "@core/foundation/types";

import { Button } from "@react/ui-primitives/button";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@react/ui-primitives/empty";

export const EmptyView: FC<{
  readonly actionLabel?: string;
  readonly description?: string;
  readonly onAction?: () => void;
  readonly title?: string;
}> = ({ actionLabel, description, onAction, title = "Nothing here yet" }) => (
  <div className="flex size-full flex-1 items-center justify-center">
    <Empty className="border-none">
      <EmptyMedia variant="icon">
        <Inbox className="text-muted-foreground" />
      </EmptyMedia>
      <EmptyHeader>
        <EmptyTitle>{title}</EmptyTitle>
        {hasValue(description) && (
          <EmptyDescription>{description}</EmptyDescription>
        )}
      </EmptyHeader>
      {hasValue(actionLabel) && (
        <EmptyContent>
          <Button onClick={onAction} variant="outline">
            {actionLabel}
          </Button>
        </EmptyContent>
      )}
    </Empty>
  </div>
);
